<template>
  <v-dialog v-model="dialog" persistent width="700px">
    <v-toolbar flat class="text-h5 grey--text  text--darken-3">
      <v-toolbar-title>Lista de layouts</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="closeModal()" icon
        ><v-icon>mdi-close-circle</v-icon></v-btn
      >
    </v-toolbar>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center">
              Arquivo
            </th>
            <th class="text-center">
              Layout
            </th>
            <th class="text-center">
              Novo
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in response" :key="item.name">
            <td>{{ item.filename }}</td>
            <td>{{ item.nameLayout }}</td>
            <td v-if="item.isNew">
              <v-icon color="success">mdi-check-circle</v-icon>
            </td>
            <td v-else><v-icon color="error">mdi-close-circle</v-icon></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    response: {
      type: Array,
    },
  },
  methods: {
    closeModal() {
      this.$emit("upload");
    },
  },
};
</script>
